import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean;
    title: string;
    messages: string[];
    confirmLabel: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmUnpayableDecline = (props: IProps) => {
    return (
        <Modal backdrop="static" show={props.show} onHide={props.onCancel} className="modal-vertical-center" style={{ display: 'flex', alignItems: 'center' }}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.messages.map((line, index) => (
                    <p
                        key={index}
                        style={{
                            marginTop: index === 0 ? 0 : 12,
                            marginBottom: 0,
                            fontSize: index === 0 ? 15 : 14,
                            lineHeight: 1.5,
                            color: '#333',
                            fontWeight: index === 0 ? 700 : index === props.messages.length - 1 ? 600 : 400
                        }}
                    >
                        {line}
                    </p>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onCancel}>Cancel</Button>
                <Button bsStyle="danger" onClick={props.onConfirm}>{props.confirmLabel}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmUnpayableDecline;
